import type { TagGroup } from '@vision/ui/interfaces';
import type { AccountTag } from '@vision/ui/interfaces/account-tag';
import type {
  AccountTagResponseDto,
  GetTagGroupsArgs,
  GetTagsArgs,
  SaveTagGroupInput,
  TagGroupResponseDto,
} from './tag.service.types';

type TagGroupsRequestDto = {
  page?: number;
  per_page?: number;
  tag_group_name?: string;
  include_internal?: boolean;
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
  tag_group_ids?: string;
};

export function toTagGroupsRequestDto(args: GetTagGroupsArgs): TagGroupsRequestDto {
  return {
    page: args.page,
    per_page: args.perPage,
    tag_group_name: args.search,
    include_internal: args.includeInternal,
    sort_by: args.sortBy,
    sort_order: args.sortOrder,
    tag_group_ids: args.ids?.join(','),
  };
}

type TagsRequestDto = {
  page?: number;
  per_page?: number;
  tag_name?: string;
  include_internal?: boolean;
  tag_group_ids?: string;
  ids?: string;
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
};

export function toTagsRequestDto(args: GetTagsArgs): TagsRequestDto {
  return {
    page: args.page,
    per_page: args.perPage,
    tag_name: args.search,
    include_internal: args.includeInternal,
    tag_group_ids: args.tagGroups?.length ? args.tagGroups.join(',') : undefined,
    ids: args.ids?.join(','),
    sort_by: args.sortBy,
    sort_order: args.sortOrder,
  };
}

export function fromApiTagGroup(group: TagGroupResponseDto): TagGroup {
  return { id: group.id, accountId: group.account_id, name: group.name };
}

export function fromApiTag(tag: AccountTagResponseDto): AccountTag {
  return {
    id: tag.id,
    name: tag.name,
    tagGroupId: tag.tag_group_id,
    tagGroupName: tag.tag_group_name,
    backgroundColor: tag.background_color,
    fontColor: tag.font_color,
  };
}

type SaveTagGroupRequestDto = {
  id?: string;
  account_id?: string;
  name: string;
  tags: { id?: string; name: string; background_color?: string; font_color?: string }[];
};

export function toSaveTagGroupRequestDto(group: SaveTagGroupInput): SaveTagGroupRequestDto {
  return {
    id: group.id,
    account_id: group.accountId,
    name: group.name,
    tags: group.tags.map((tag) => ({
      id: tag.id || undefined,
      name: tag.name,
      background_color: tag.backgroundColor,
      font_color: tag.fontColor,
    })),
  };
}
